// extracted by mini-css-extract-plugin
module.exports = {"image":"jgp-2rdBm","name":"jgp-ZtDFY","logoWrapper":"jgp-1p2Fs","logoImage":"jgp-3rLLX"};